import { IconCross } from "../icons/IconCross";

export function ButtonCross({
  onClick,
  disabled,
  title,
}: {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <button
      className="flex items-center justify-center w-6 h-6 rounded-full bg-red-100 hover:bg-red-200 dark:bg-red-900/40 dark:hover:bg-red-800/60 border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 transition disabled:opacity-50 disabled:cursor-not-allowed"
      title={title}
      onClick={onClick}
      disabled={disabled}
    >
      <IconCross className="size-4" />
    </button>
  );
}
